import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createAffiliate(context, affiliateData) {
    return new Promise((resolve, reject) => {
      axios
        .post('affiliates', affiliateData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countAffiliates(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`affiliates/count/?${query}`)
        .then(response => {
          context.commit('SET_AFFILIATE_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  getAffiliateCode() {
    return new Promise((resolve, reject) => {
      axios
        .get('affiliates/code')
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchAffiliates(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`affiliates/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_AFFILIATE', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchAffiliate(context, affiliateId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`affiliates/${affiliateId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeAffiliate({ commit }, affiliateId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`affiliates/${affiliateId}`)
        .then(response => {
          commit('REMOVE_RECORD', affiliateId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editAffiliate(context, affiliate) {
    return new Promise((resolve, reject) => {
      axios
        .put(`affiliates/${affiliate.id}`, affiliate.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
